import { Button, Helper, Icon, CheckBox } from 'Components';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import React, { Fragment, useContext } from 'react';
import DeletionContext from 'src/MultiDeletionFunctionality/@state/DeletionStateContext';
import DELETE_ACTIONS from 'src/MultiDeletionFunctionality/@state_manager/actions';
import PowerTablePopover from '../PowerTablePopover/PowerTablePopover';
import './PowerTableTrLeft.css';

const PowerTableTrLeft = (props) => {
  const { deletionState, dispatch } = useContext(DeletionContext);

  return (
    <div className="power-table-tr-left">
      {/* // ! Showing checkboxes for each row: */}
      {deletionState.isDeletionModeActive &&
      //! This is the row information:
      deletionState.data[props.i] &&
      deletionState.itemsAllowedToDelete.includes(
        deletionState.data[props.i][deletionState.idName],
      ) ? (
        // TODO: Add Condition to check if the user is qualified to delete the row:
        <div>
          <CheckBox
            checked={deletionState.selectedItems.includes(
              deletionState.data[props.i][deletionState.idName],
            )}
            onClick={() => {
              dispatch({
                type: DELETE_ACTIONS.TOGGLE_ADD_ITEM_TO_SELECTED_ITEMS,
                payload: {
                  id: deletionState.data[props.i][deletionState.idName],
                },
              });
            }}
          />
        </div>
      ) : deletionState.isDeletionModeActive ? (
        <BoxPlaceHolder />
      ) : null}

      {props.hasPins && (
        <div className="power-table-tr-left__button">
          <Helper text={i18n.t('tutorials:common.pinnedOrders')}>
            <Button onClick={props.onPinClick}>
              <Icon icon={props.Pinned ? 'turned_in' : 'turned_in_not'} />
            </Button>
          </Helper>
        </div>
      )}
      {props.hasLocks && (
        <div className="power-table-tr-left__icon">
          {props.LockTemplate && <Icon icon="lock" />}
        </div>
      )}

      {props.hasDocs && (
        <div className="power-table-tr-left__button power-table-tr-left__button__popover">
          {/* Should render from props */}
          {props.leftDocumentPopover}

          {/* Legacy file icons */}
          {props.SubmissionId !== 0 && props.code === 'jobs' && (
            <Fragment>
              <Button>
                <Icon icon="description" />
              </Button>
              <PowerTablePopover
                popoverRef={props.popoverRef}
                SubmissionId={props.SubmissionId}
                isCTFDisabled={props.Status === 'C'}
              />
            </Fragment>
          )}
        </div>
      )}
    </div>
  );
};

PowerTableTrLeft.propTypes = {
  onPinClick: PropTypes.func,
  Pinned: PropTypes.bool,
  LockTemplate: PropTypes.bool,
  popoverRef: PropTypes.shape({}),
  hasPins: PropTypes.bool,
  hasLocks: PropTypes.bool,
  hasDocs: PropTypes.bool,
  Status: PropTypes.string,
  SubmissionId: PropTypes.number,
  code: PropTypes.string,
  leftDocumentPopover: PropTypes.node,
  i: PropTypes.number,
};

export default PowerTableTrLeft;

function BoxPlaceHolder() {
  return (
    <div className="power-table-tr-left__box-placeholder">
      <div className="power-table-tr-left__box-placeholder__box" />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/PowerTable/PowerTableTrLeft/PowerTableTrLeft.jsx